<template>
  <div id="app">
    <router-view />
    <FooterBar />
    <HeaderBar />
    <RightMenu />

    <ApplyDialog />
    <ContactDialog />
  </div>
</template>

<script>
import HeaderBar from "@/components/headerBar/index.vue";
import RightMenu from "@/components/rightMenu/index.vue";
import FooterBar from "@/components/footerBar/index.vue";
import ApplyDialog from "@/components/applyDialog/index.vue";
import ContactDialog from "@/components/contactDialog/index.vue";

export default {
  name: "App",
  components: {
    HeaderBar,
    RightMenu,
    FooterBar,
    ApplyDialog,
    ContactDialog,
  },
};
</script>

<style>
#app {
  font-size: 16px;
  color: #ffffff;
}
</style>
